var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      {
        directives: [
          { name: "wrap", rawName: "v-wrap:responsive", arg: "responsive" }
        ],
        class: _vm.tabsClass
      },
      _vm._l(_vm.tabs, function(tab) {
        return _c(
          "li",
          { key: tab.name, style: { flexGrow: _vm.growEnabled ? "1" : "" } },
          [
            _c(
              "a",
              {
                class: _vm.tabClass(tab),
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.selectTab(tab)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(tab.name) + "\n      ")]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tabs-container", style: _vm.containerStyle },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }